<template>
  <div class="wrapper">
    <span class="w-title">用户管理</span>
    <v-divider class="my-3"/>
    <v-container fluid grid-list-md class="xn-form pa-0">
      <v-layout wrap>
        <v-flex xs12 sm6 md3>
          <v-select
            v-model="filters.role"
            label="用户类型"
            :items="rolesItems"
            outline
            solo
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-text-field
            v-model="filters.q"
            label="用户名/姓名/联系方式"
            outline
            solo
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3 style="display: flex;margin-bottom: 20px;">
          <v-btn color="info" style="margin-right: 5px !important;" @click="refresh">查询</v-btn>
          <v-btn color="info" @click="clearFilters">重置</v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <v-btn color="info" style="margin-right: 5px !important;" @click="addButtonClicked">新建</v-btn>
    <v-btn color="error" style="margin-right: 5px !important;" :disabled="canDelete" @click="deleteButtonClicked">删除</v-btn>
    <v-btn color="success" :disabled="canExport" outline style="margin-right: 5px !important;" @click="exportButtonClicked">导出</v-btn>

    <DataTable
      ref="dataTable"
      item-key="username"
      sort-by="name"
      :headers="headers"
      :fetch-data="refreshList"
      @editButtonClicked="editButtonClicked"
      @detailButtonClicked="detailButtonClicked"
      @statusButtonClicked="statusButtonClicked"
    ></DataTable>
  </div>
</template>

<script>
  import axios from "../axios";
  import DataTable from "../components/DataTable2";
  import {mapActions} from 'vuex';

  export default {
    mounted() {
      this.isMounted = true;
    },
    components: {
      DataTable
    },
    computed: {
      canDelete() {
        if (this.isMounted) {
          return this.$refs.dataTable.selected.length === 0;
        } else {
          return false;
        }
      },
      canExport() {
        if (this.isMounted) {
          return this.$refs.dataTable.data.length === 0;
        } else {
          return false;
        }
      },
      headers() {
        let ret = [
          {text: "用户名",align: "left",value: "username"},
          {text: "姓名",align: "left",value: "name"},
          {text: "联系方式",align: "left",value: "phoneNumber"},
          {text: "用户类别",align: "left",value: "role",formatter: v => this.rolesMapping[v]},
          {text: "公司",align: "left",value: "companyName"},
          {text: "事务所",align: "left",value: "firmName"},
          {text: "状态",align: "left",value: "isTerminated",formatter:v=>{
            return v?'已禁用':'已开通'
          }},
          {text: "操作", align: "center", value: "settings", sortable: false}
        ];
        return ret;
      }
    },
    data: () => ({
      isMounted: false,
      filters: {},
      rolesMapping: {
        "super": "超级管理员",
        admin: "事务所管理员",
        branch: "事务所分公司管理员",
        firm: "事务所员工",
        user: "客户",
      },
      ts: '',
      params: null,
    }),
    methods: {
      ...mapActions(["setLoading"]),
      refreshList(pagination, searchText, callback, failure) {
        this.params = {
          params: {
            page: pagination.page - 1,
            size: pagination.rowsPerPage === -1 ? 2147483647 : pagination.rowsPerPage,
            sort:
              pagination.sortBy === null
                ? null
                : pagination.sortBy +
                "," +
                (pagination.descending ? "desc" : "asc"),
            // search: searchText,
            companyId: this.$currentCompany ? this.$currentCompany.id : null,
            "role.role": this.filters.role,
            ...this.filters
          }
        };

        axios
          .get("/users", this.params)
          .then(response => {
            callback(response.data.total, response.data.data);
          })
          .catch(reason => {
            if (failure) {
              failure(reason);
            }
          });
      },
      exportButtonClicked() {
        this.setLoading(true);
        axios
          .get("/users/export", { ...this.params, responseType: "arraybuffer" })
          .then(response => {
            this.saveAs(new Blob([response.data]), "用户.csv");
            this.setLoading(false);
          })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {buttonFalseText: null});
            this.setLoading(false);
          });
      },
      addButtonClicked() {
        this.$router.push({
          name: "user-form-add"
        });
      },
      editButtonClicked(item) {
        this.$router.push({
          name: "user-form-edit",
          params: {username: item.username}
        });
      },
      detailButtonClicked(item) {
        this.$router.push({
          name: "user-form-detail",
          params: {username: item.username}
        });
      },
      statusButtonClicked(item) {
        //切换用户状态
        let isTerminated = !item.isTerminated;
        this.setLoading(true);
        axios
          .patch("/users/" + item.username, {
            isTerminated: isTerminated
          })
          .then((res) => {
            //this.$refs.dataTable.btnLoading = false;
            this.refresh();
            this.setLoading(false);

            this.$refs.dataTable.selected=[];
          })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {
              buttonFalseText: null
            });
            this.setLoading(false);

            this.$refs.dataTable.selected=[];
          });
      },
      deleteButtonClicked() {
        let items = this.$refs.dataTable.selected;
        this.$confirm("正在删除" + items.length + "个用户，请确认").then(res => {
          if (res) {
            this.setLoading(true);
            axios
              .post("/users/delete", {
                usernames: items.map(item => item.username)
              })
              .then(() => {
                this.setLoading(false);

                this.$confirm("删除成功", {buttonFalseText: null}).then(() => {
                    this.refresh();
                  }
                );
              })
              .catch(reason => {
                this.$confirm(reason.response.data.message, {
                  buttonFalseText: null
                });
                this.setLoading(false);
              });
          }
        });
      },
      refresh() {
        this.$refs.dataTable.refresh();
      },
      clearFilters() {
        this.filters = {};
        this.refresh();
      }
    }
  };
</script>
